import { createSelector } from 'reselect';

import { contributionTypes, offsetCategories } from '/business/shared/util/Statics';

import getTotalTonnageWithSafetyFactorSelector from '/business/shared/state/selectors/application/carbon/getTotalTonnageWithSafetyFactorSelector';
import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';
import getApplicationCarbonCostPerTonneSelector from '/business/shared/state/selectors/application/offset/getApplicationPayCurrencyCarbonCostPerTonneSelector';
import getApplicationOffsetCategorySelector from '/business/shared/state/selectors/application/offset/getApplicationOffsetCategorySelector';

export default createSelector(
  [
    getApplicationSelector,
    getTotalTonnageWithSafetyFactorSelector,
    getApplicationCarbonCostPerTonneSelector,
    getApplicationOffsetCategorySelector,
  ],
  (application = null, totalTonnes = 0, carbonCostPerTonne, offsetCategory = null) => {
    const totalCost = carbonCostPerTonne === undefined ? Number.NaN : carbonCostPerTonne * totalTonnes;
    const isPaymentFullyCoveredByContribution =
      (application?.contributionType === contributionTypes.PERCENTAGE && application?.contributionValue === 100) ||
      (application?.contributionType === contributionTypes.FIXED_AMOUNT && application?.contributionValue >= totalCost);

    const isOffsetPaymentNotRequired = offsetCategory === offsetCategories.NO_OFFSET;

    if (isPaymentFullyCoveredByContribution) {
      return false;
    }

    if (isOffsetPaymentNotRequired) {
      return true;
    }

    if (!offsetCategory) {
      return true;
    }

    return false;
  },
);
